var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP20TipBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3839 20.7959L22.9534 20.76L22.9607 22.0885L16.3912 22.1244L16.3839 20.7959Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 20,
    width: 7,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7125 20.7939L22.6252 20.7616L22.3588 32.0558L21.9981 32.0577L21.7347 38.0376L21.381 38.0395L20.5599 63.2891L19.2459 63.2941L18.1469 38.0572L17.793 38.0591L17.4645 32.0825L17.1032 32.0845L16.7125 20.7939Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.3843 20.8135L22.9535 20.7411L22.712 32.0369L16.8727 32.1013L16.3843 20.8135Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.5005 31.4414L23.0697 31.369L22.9648 38.0132L16.7507 38.0817L16.5005 31.4414Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.8797 37.4053L21.8212 37.3619L20.7906 63.281L19.4768 63.2955L17.8797 37.4053Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5743 63.2927L18.0338 21.4598L16.72 21.4743L16.6182 63.3143L19.5743 63.2927Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2314 63.2856L21.3185 21.4238L22.6324 21.4093L23.1876 63.2694L20.2314 63.2856Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9611 22.0887L16.3914 22.125L16.4027 22.8068L22.9645 22.7526L22.9611 22.0887ZM16.608 32.1051L22.4201 32.0407L22.4073 32.7048L16.515 32.7701L16.608 32.1051ZM17.9527 38.0689L21.7629 38.0267L21.7569 38.6908L17.8942 38.7336L17.9527 38.0689Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.6994 20.4951L50.2689 20.4592L50.2763 21.7877L43.7067 21.8236L43.6994 20.4951Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 20,
    width: 6,
    height: 43
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0281 20.4932L49.9407 20.4608L49.6744 31.755L49.3136 31.7569L49.0503 37.7368L48.6966 37.7387L47.8754 62.9883L46.5615 62.9933L45.4624 37.7564L45.1086 37.7583L44.7801 31.7817L44.4187 31.7837L44.0281 20.4932Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.6998 20.5127L50.2691 20.4403L50.0276 31.7362L44.1882 31.8005L43.6998 20.5127Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.816 31.1406L50.3853 31.0683L50.2804 37.7125L44.0662 37.7809L43.816 31.1406Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M45.1953 37.1045L49.1368 37.0611L48.1062 62.9803L46.7923 62.9947L45.1953 37.1045Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8899 62.9919L45.3494 21.1591L44.0355 21.1735L43.9337 63.0135L46.8899 62.9919Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5469 62.9848L48.6341 21.123L49.9479 21.1085L50.5032 62.9686L47.5469 62.9848Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2766 21.7879L43.707 21.8242L43.7182 22.506L50.2801 22.4518L50.2766 21.7879ZM43.9235 31.8043L49.7357 31.7399L49.7229 32.404L43.8305 32.4693L43.9235 31.8043ZM45.2682 37.7681L49.0784 37.7259L49.0725 38.39L45.2097 38.4328L45.2682 37.7681Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.7043 20.6387L37.2738 20.6028L37.2811 21.9313L30.7116 21.9672L30.7043 20.6387Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 20,
    width: 6,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.033 20.6367L36.9456 20.6044L36.6793 31.8985L36.3185 31.9005L36.0552 37.8803L35.7015 37.8823L34.8803 63.1319L33.5664 63.1368L32.4673 37.9L32.1134 37.9019L31.785 31.9253L31.4236 31.9273L31.033 20.6367Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.7047 20.6562L37.274 20.5839L37.0325 31.8797L31.1931 31.944L30.7047 20.6562Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.8209 31.2842L37.3902 31.2118L37.2853 37.856L31.0711 37.9245L30.8209 31.2842Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M32.2001 37.248L36.1417 37.2046L35.111 63.1238L33.7972 63.1383L32.2001 37.248Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8947 63.1355L32.3543 21.3026L31.0404 21.3171L30.9386 63.1571L33.8947 63.1355Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5518 63.1283L35.6389 21.2665L36.9528 21.2521L37.5081 63.1122L34.5518 63.1283Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2815 21.9315L30.7119 21.9678L30.7231 22.6495L37.285 22.5954L37.2815 21.9315ZM30.9284 31.9479L36.7406 31.8835L36.7277 32.5476L30.8354 32.6128L30.9284 31.9479ZM32.2731 37.9117L36.0833 37.8695L36.0774 38.5336L32.2146 38.5764L32.2731 37.9117Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.4254 19.2178L26.5921 19.1786L26.6001 20.6279L19.4333 20.6671L19.4254 19.2178Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 8,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7839 19.2158L26.234 19.1806L25.9435 31.5014L25.5499 31.5036L25.2626 38.0271L24.8768 38.0292L23.981 65.5742L22.5476 65.5796L21.3486 38.0485L20.9626 38.0506L20.6043 31.5306L20.21 31.5328L19.7839 19.2158Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.4258 19.2373L26.5923 19.1584L26.3288 31.4811L19.9587 31.5512L19.4258 19.2373Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.5526 30.8311L26.7191 30.7521L26.6046 38.0003L19.8255 38.075L19.5526 30.8311Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.0572 37.3369L25.3571 37.2896L24.2327 65.565L22.7994 65.5808L21.0572 37.3369Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9059 65.5782L21.2254 19.9423L19.7921 19.9581L19.681 65.6018L22.9059 65.5782Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6226 65.5701L24.8086 19.9027L26.2419 19.8869L26.8477 65.5525L23.6226 65.5701Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6005 20.6274L19.4336 20.667L19.4459 21.4107L26.6043 21.3517L26.6005 20.6274ZM19.6698 31.5543L26.0104 31.4841L25.9964 32.2086L19.5684 32.2798L19.6698 31.5543ZM21.1368 38.0603L25.2934 38.0143L25.2869 38.7388L21.073 38.7855L21.1368 38.0603Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M33.7459 19.0596L40.9127 19.0204L40.9207 20.4697L33.7539 20.5088L33.7459 19.0596Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 19,
    width: 7,
    height: 47
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1044 19.0576L40.5546 19.0224L40.264 31.3432L39.8705 31.3454L39.5832 37.8688L39.1973 37.871L38.3015 65.416L36.8682 65.4214L35.6692 37.8902L35.2831 37.8924L34.9248 31.3724L34.5306 31.3746L34.1044 19.0576Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M33.7464 19.0791L40.9128 19.0002L40.6494 31.3229L34.2792 31.393L33.7464 19.0791Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M33.8732 30.6729L41.0396 30.5939L40.9252 37.8421L34.1461 37.9168L33.8732 30.6729Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.3777 37.1787L39.6776 37.1313L38.5533 65.4068L37.12 65.4226L35.3777 37.1787Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2264 65.42L35.5459 19.7841L34.1126 19.7999L34.0016 65.4436L37.2264 65.42Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9432 65.4119L39.1292 19.7445L40.5625 19.7287L41.1682 65.3943L37.9432 65.4119Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9211 20.4692L33.7542 20.5088L33.7664 21.2525L40.9248 21.1935L40.9211 20.4692ZM33.9904 31.3961L40.3309 31.3259L40.3169 32.0504L33.889 32.1216L33.9904 31.3961ZM35.4573 37.9021L39.6139 37.8561L39.6075 38.5806L35.3935 38.6273L35.4573 37.9021Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.3017 18.9102L54.4685 18.871L54.4764 20.3203L47.3097 20.3594L47.3017 18.9102Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 18,
    width: 8,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6602 18.9082L54.1104 18.8729L53.8198 31.1938L53.4263 31.196L53.139 37.7194L52.7531 37.7215L51.8573 65.2666L50.4239 65.272L49.2249 37.7408L48.8389 37.7429L48.4806 31.223L48.0864 31.2252L47.6602 18.9082Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.3022 18.9297L54.4686 18.8507L54.2052 31.1735L47.835 31.2436L47.3022 18.9297Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.429 30.5234L54.5954 30.4445L54.481 37.6927L47.7019 37.7674L47.429 30.5234Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M48.9335 37.0293L53.2334 36.9819L52.1091 65.2574L50.6758 65.2732L48.9335 37.0293Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7822 65.2706L49.1017 19.6347L47.6684 19.6505L47.5574 65.2942L50.7822 65.2706Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.499 65.2625L52.6849 19.5951L54.1182 19.5793L54.724 65.2449L51.499 65.2625Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4768 20.3198L47.3099 20.3594L47.3222 21.1031L54.4806 21.0441L54.4768 20.3198ZM47.5462 31.2467L53.8867 31.1765L53.8727 31.901L47.4447 31.9722L47.5462 31.2467ZM49.0131 37.7527L53.1697 37.7067L53.1632 38.4312L48.9493 38.4778L49.0131 37.7527Z",
    fill: "#333333"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.35034 17.0098L16.9949 16.968L17.0035 18.538L9.35899 18.5798L9.35034 17.0098Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 8,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73273 17.0078L16.6129 16.9702L16.3041 30.3178L15.8843 30.3201L15.5785 37.3871L15.1669 37.3894L14.2139 67.2297L12.685 67.2354L11.4035 37.41L10.9917 37.4122L10.6089 30.3489L10.1884 30.3512L9.73273 17.0078Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.35083 17.0312L16.995 16.9464L16.7151 30.296L9.92029 30.3714L9.35083 17.0312Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.48712 29.5908L17.1313 29.506L17.0099 37.3582L9.77889 37.4384L9.48712 29.5908Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.0926 36.6387L15.6791 36.5878L14.4824 67.2194L12.9536 67.2364L11.0926 36.6387Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0671 67.2341L11.2704 17.7951L9.74155 17.8121L9.62728 67.2594L13.0671 67.2341Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8316 67.2255L15.0925 17.7526L16.6213 17.7356L17.2717 67.2067L13.8316 67.2255Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0039 18.5381L9.35931 18.5811L9.37241 19.3861L17.008 19.3221L17.0039 18.5381ZM9.61224 30.3756L16.3755 30.2995L16.3606 31.0838L9.50404 31.1609L9.61224 30.3756ZM11.1776 37.4237L15.6113 37.3738L15.6044 38.1583L11.1095 38.2089L11.1776 37.4237Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.8743 16.8496L31.5189 16.8078L31.5275 18.3779L23.883 18.4197L23.8743 16.8496Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 16,
    width: 8,
    height: 52
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2567 16.8477L31.1369 16.81L30.8281 30.1576L30.4083 30.1599L30.1025 37.227L29.6909 37.2292L28.7379 67.0696L27.2089 67.0753L25.9275 37.2498L25.5157 37.2521L25.1329 30.1888L24.7124 30.1911L24.2567 16.8477Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.8748 16.8711L31.519 16.7862L31.2391 30.1358L24.4443 30.2112L23.8748 16.8711Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.0111 29.4307L31.6553 29.3458L31.5339 37.198L24.3029 37.2783L24.0111 29.4307Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.6166 36.4785L30.2031 36.4276L29.0064 67.0592L27.4776 67.0762L25.6166 36.4785Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5911 67.074L25.7944 17.635L24.2655 17.652L24.1513 67.0992L27.5911 67.074Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3556 67.0654L29.6165 17.5925L31.1453 17.5755L31.7957 67.0466L28.3556 67.0654Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5279 18.3779L23.8833 18.4209L23.8964 19.2259L31.5319 19.1619L31.5279 18.3779ZM24.1362 30.2154L30.8995 30.1394L30.8846 30.9236L24.028 31.0008L24.1362 30.2154ZM25.7016 37.2635L30.1353 37.2136L30.1284 37.9981L25.6335 38.0487L25.7016 37.2635Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.6339 16.6973L45.2785 16.6555L45.2871 18.2255L37.6426 18.2673L37.6339 16.6973Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 16,
    width: 7,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0163 16.6953L44.8965 16.6577L44.5877 30.0053L44.1679 30.0076L43.862 37.0746L43.4505 37.0769L42.4975 66.9172L40.9685 66.923L39.6871 37.0975L39.2753 37.0997L38.8925 30.0364L38.472 30.0387L38.0163 16.6953Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.6344 16.7188L45.2786 16.6339L44.9987 29.9835L38.2039 30.0589L37.6344 16.7188Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.7707 29.2783L45.4149 29.1935L45.2935 37.0457L38.0625 37.1259L37.7707 29.2783Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M39.3762 36.3262L43.9627 36.2753L42.766 66.9069L41.2372 66.9239L39.3762 36.3262Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3507 66.9216L39.554 17.4826L38.0251 17.4996L37.9109 66.9469L41.3507 66.9216Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1152 66.913L43.3761 17.4401L44.9049 17.4231L45.5552 66.8942L42.1152 66.913Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2875 18.2256L37.6429 18.2686L37.656 19.0736L45.2915 19.0096L45.2875 18.2256ZM37.8958 30.0631L44.6591 29.987L44.6442 30.7713L37.7876 30.8484L37.8958 30.0631ZM39.4611 37.1112L43.8949 37.0613L43.888 37.8458L39.3931 37.8964L39.4611 37.1112Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.1579 16.5381L59.8025 16.4963L59.8111 18.0663L52.1665 18.1081L52.1579 16.5381Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 16,
    width: 8,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5403 16.5361L59.4205 16.4985L59.1117 29.8461L58.6919 29.8484L58.386 36.9155L57.9745 36.9177L57.0214 66.7581L55.4925 66.7638L54.211 36.9383L53.7993 36.9405L53.4165 29.8772L52.996 29.8795L52.5403 16.5361Z",
    fill: "#F7EFC7"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.1584 16.5596L59.8026 16.4747L59.5227 29.8243L52.7279 29.8997L52.1584 16.5596Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M52.2947 29.1191L59.9389 29.0343L59.8175 36.8865L52.5864 36.9668L52.2947 29.1191Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M53.9001 36.167L58.4867 36.1161L57.29 66.7477L55.7611 66.7647L53.9001 36.167Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8747 66.7624L54.0779 17.3235L52.5491 17.3404L52.4348 66.7877L55.8747 66.7624Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6392 66.7539L57.9 17.2809L59.4289 17.264L60.0792 66.735L56.6392 66.7539Z",
    fill: "#F7EFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8115 18.0664L52.1669 18.1094L52.18 18.9144L59.8155 18.8504L59.8115 18.0664ZM52.4198 29.9039L59.1831 29.8279L59.1682 30.6121L52.3116 30.6892L52.4198 29.9039ZM53.9851 36.952L58.4189 36.9021L58.412 37.6866L53.9171 37.7372L53.9851 36.952Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66734 29.6364C6.56284 29.6486 5.67725 30.5538 5.68932 31.6583L5.74406 36.6647L3.15741 36.6932C2.05291 36.7054 1.16732 37.6106 1.1794 38.7151L1.19158 39.8292L5.82732 39.7781C6.03861 40.6672 6.84272 41.324 7.79501 41.3136L61.8913 40.7177C62.8435 40.7072 63.6331 40.0328 63.8249 39.1392L69.2251 39.0798L69.2129 37.9657C69.2008 36.8612 68.2956 35.9757 67.1911 35.9879L63.8401 36.0248L63.7853 31.0184C63.7733 29.9139 62.8681 29.0284 61.7636 29.0406L7.66734 29.6364Z",
    fill: "#F7DD89"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5468 36.0501L8.03732 36.6395L7.74394 36.6427L5.74406 36.6647L5.72219 34.6649L5.71001 33.5508L5.68932 31.6584C5.67725 30.5538 6.56284 29.6486 7.66734 29.6364L7.96072 29.6332L8.00328 33.5256L61.5128 32.9362L61.4702 29.0438L61.7636 29.0406C62.8681 29.0284 63.7733 29.9139 63.7853 31.0184L63.806 32.9109L63.8182 34.0249L63.8401 36.0248L61.8402 36.0468L61.5468 36.0501ZM1.1794 38.7151C1.16732 37.6106 2.05291 36.7054 3.15741 36.6932L3.4508 36.69L3.48484 39.8039L1.19158 39.8292L1.1794 38.7151ZM67.1911 35.9879L66.8977 35.9911L66.9318 39.105L69.2251 39.0798L69.2129 37.9657C69.2008 36.8612 68.2956 35.9757 67.1911 35.9879Z",
    fill: "#DABE64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.623 41.1661C66.5411 41.4189 66.4418 41.7425 66.3299 42.1406C66.0145 43.2625 65.5992 44.9751 65.1922 47.356C64.3909 52.0434 63.6217 59.3216 63.7098 69.7837L55.134 69.8782L53.3055 69.1567L53.2144 69.1208L53.1165 69.1218L17.1887 69.5176L17.0908 69.5187L17.0005 69.5566L15.1882 70.3182L7.37692 70.4042C7.24087 60.1355 6.40742 52.8808 5.59907 48.1689C5.18837 45.7748 4.78415 44.0373 4.48118 42.8943C4.36723 42.4645 4.2676 42.1187 4.18735 41.8538L66.623 41.1661Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49335 40.583C3.49335 40.583 6.64465 49.1126 6.87445 70.1314L15.2831 70.0388L17.1856 69.2392L53.1134 68.8435L55.033 69.6009L64.206 69.4999C63.972 48.0918 66.9403 39.8841 66.9403 39.8841",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19159 39.8301L69.2251 39.0807V39.0807C69.2345 39.9406 68.545 40.6453 67.6851 40.6548L2.76556 41.3699C1.90568 41.3794 1.20099 40.69 1.19159 39.8301V39.8301Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4956 68.8388L53.3518 55.68C53.3084 51.7123 48.0965 45.5412 35.0657 45.6847C22.0348 45.8282 16.6162 52.1165 16.6596 56.0842L16.8034 69.2429",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 15.2893,
    height: 4.67113,
    rx: 1,
    transform: "matrix(0.999939 -0.0110144 0.0109324 0.99994 27.2245 43.4355)",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9772 5.84987L16.2579 6.40609L16.8809 6.39923L51.6621 6.01611L52.1675 6.01054L52.4628 5.60027L53.2971 4.44096L64.8325 4.3139L66.6035 34.9942L2.95884 35.6952L4.05856 4.98333L15.4764 4.85756L15.9772 5.84987Z",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1055 5.40723L17.7025 11.6182",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7977 5.00391L51.337 11.2485",
    stroke: "#E5ECF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2294 6.11914L46.6909 5.8497L46.7456 10.8561C46.7577 11.9606 45.8721 12.8658 44.7676 12.878L24.3059 13.1034C23.2014 13.1156 22.2962 12.23 22.2842 11.1255L22.2294 6.11914Z",
    stroke: "#E5ECF0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.01087,
    y: 0.988926,
    width: 14.8183,
    height: 13.5704,
    rx: 2,
    transform: "matrix(0.999939 -0.0110144 0.0109324 0.99994 26.3557 34.8911)",
    fill: "#F5F7F9",
    fillOpacity: 0.6,
    stroke: "#E5ECF0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5665,
    height: 69.57,
    fill: "white",
    transform: "matrix(0.999939 -0.0110144 0.0109324 0.99994 0 0.766602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 16.384 20.7959)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56965,
    height: 42.5128,
    fill: "white",
    transform: "matrix(0.999985 -0.00546694 0.00550611 0.999985 43.6995 20.4951)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.56964,
    height: 42.5128,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 30.7044 20.6387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 19.4255 19.2178)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 33.746 19.0596)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.16688,
    height: 46.3776,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 47.3018 18.9102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2424,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 9.35046 17.0098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2424,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 23.8745 16.8496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2424,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 37.634 16.6973)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.64468,
    height: 50.2424,
    fill: "white",
    transform: "matrix(0.999985 -0.00546693 0.00550611 0.999985 52.158 16.5381)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP20TipBox);
export default __webpack_public_path__ + "static/media/P20_Tip_Box.42eb0119df041016cf9792c19f72c4c0.svg";
export { ForwardRef as ReactComponent };